// Enlaces que no deben disparar el anuncio a pantalla completa de AdSense.
//
// El "vignette" se interpone entre una página y la siguiente. Paga bien y en el
// resto del sitio queda como está, pero en el recorrido entre herramientas —de la
// calculadora de ascendente al mapa astral, de una tirada a la siguiente— cortar
// a alguien que está metido en lo que hace es caro: es justo la visita que vuelve.
//
// Google respeta este atributo en el <a> y no muestra el vignette al hacer clic
// en ese enlace concreto. No esconde ni cambia ningún anuncio: sólo evita el corte
// en esos saltos. Se usa así:  <Link to="/mapa-astral/" {...SEM_VIGNETTE}>
export const SEM_VIGNETTE = { "data-google-vignette": "false" }
